angular
	.module 'App.Module.LayoutTemplate',
		[
			'gridster',
			'ngDragDrop',
			'ui.sortable',
		]
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'layout_template',
				url: '/layout_templates'
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
				data:
					restrict: 'Backoffice.Permission.LayoutTemplates.Enabled'

			.state 'layout_template.edit',
				url: '/:id'
				abstract: true
				views:
					'entity_search@layout_template':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				data:
					searchParams:
						repositoryName: 'LayoutTemplateRepository'
						title: 'wbo.title.layout.templates.list'
						labelTemplate: '@app/layout-template/layout-template.search-label.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					templateEntity: (LayoutTemplateRepository, $stateParams) ->
						query = LayoutTemplateRepository.createQuery()
						query.with 'layout_folders',
							'layout_folders.items',
							'layout_folders.items.product',
							'layout_folders.items.layout_folder'

						return LayoutTemplateRepository.getEntity $stateParams.id, query

			.state 'layout_template.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'LayoutTemplateController'
						controllerAs: 'vm'
						templateUrl: '@app/layout-template/layout-template.view.html'
